import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    on: translate({
      id: 'global.on',
    }),
    off: translate({
      id: 'global.off',
    }),

    notificationTime: translate({
      id: 'sms4.settings.communication.notifications.form.notificationCutoffMins.label',
    }),

    notificationType: translate({
      id: 'sms4.settings.communication.notifications.form.notificationWay.label',
    }),

    email: translate({
      id: 'global.email',
    }),

    emailSubject: translate({
      id: 'sms4.settings.communication.notifications.form.subjectCustom.label',
    }),

    emailText: translate({
      id: 'sms4.settings.communication.notifications.form.message.email.label',
    }),

    smsText: translate({
      id: 'sms4.settings.communication.notifications.form.message.sms.label',
    }),

    trackingLink: translate({
      id: 'sms4.settings.communication.notifications.form.trackingLink.label',
    }),

    unsubscribeInstructions: translate({
      id: 'sms4.settings.communication.notifications.form.unsubscribeInstructions.label',
    }),

    emailBackup: translate({
      id: 'sms4.settings.communication.notifications.form.backupNotification.label',
    }),

    segmentsCount: (count: number) =>
      translate({ id: 'sms4.hotwordsField.segmentsCount', values: { count } }),
  }))

  return api
}
